import logger from 'helpers/logger';

import { GetEpAgreementWallContextQuery } from '../../../graphql/queries/getEpAgreementWallContext.gql';
import { getIsAgreementDone } from './getIsAgreementDone';
import { getIsComplianceDone } from './getIsComplianceDone';
import { getIsRegistrationDateDone } from './getIsRegistrationDateDone';

export const EP_AGREEMENT_WALL_STEPS_STORAGE_KEY = 'epAgreementWallSteps';

type Steps = 'AGREEMENT' | 'COMPLIANCE' | 'REGISTRATION_DATE';

const isValidStep = (input: unknown): input is Steps => {
  if (typeof input !== 'string') {
    return false;
  }

  return ['AGREEMENT', 'COMPLIANCE', 'REGISTRATION_DATE'].includes(input);
};

export const getSteps = (moduleData: GetEpAgreementWallContextQuery) => {
  const steps = new Set<Steps>();

  if (!getIsAgreementDone(moduleData)) {
    steps.add('AGREEMENT');
  }

  if (!getIsComplianceDone(moduleData)) {
    steps.add('COMPLIANCE');
  }

  if (!getIsRegistrationDateDone(moduleData)) {
    steps.add('REGISTRATION_DATE');
  }

  try {
    const storedSteps = JSON.parse(
      sessionStorage.getItem(EP_AGREEMENT_WALL_STEPS_STORAGE_KEY) || 'null',
    );

    if (storedSteps) {
      storedSteps.forEach((storedStep: unknown) => {
        if (isValidStep(storedStep)) {
          steps.add(storedStep);
        }
      });
    }
  } catch (e) {
    logger.info(
      `Failed to parse ${EP_AGREEMENT_WALL_STEPS_STORAGE_KEY} from sessionStorage`,
    );
  }

  sessionStorage.setItem(
    EP_AGREEMENT_WALL_STEPS_STORAGE_KEY,
    JSON.stringify([...steps]),
  );

  return steps;
};
